module.exports = __webpack_public_path__ + "img/vof.c4c8a9bb.webp";